import keys from "./tkeys.json";
export const tKeys = keys;
